export interface ControlsProps {
	navigationBulletCount: number;
	onDismiss?: () => void;
	navigationBulletControlEnabled?: boolean;
}

export enum ButtonActionType {
	DISMISS = 'dismiss',
	NEXT = 'next',
	DONE = 'done',
}

export type ButtonProps = {
	onClick: () => void;
	isEnd?: boolean;
	buttonActionType: ButtonActionType;
};

export type NavigationBulletProps = {
	position: number;
	activePosition: number;
	onNavigationBulletClick: (position: number) => void;
};

export type NavigationBulletGroupProps = Omit<NavigationBulletProps, 'position'> & {
	count: number;
};

export enum ChevronDirection {
	RIGHT = 'right',
	LEFT = 'left',
}
export type ChevronProps = {
	direction: ChevronDirection;
	onPrevious?: () => void;
	onNext?: () => void;
};
